import { WorkspaceStatusTab } from './WorkspacesGrid'

export function WorkspacesTable({
  searchString,
  statusTab: _statusTab,
}: {
  searchString: string
  statusTab: WorkspaceStatusTab
}) {
  return (
    <div>
      <h1>Workspaces Table</h1>
    </div>
  )
}
